<mat-card appearance="outlined">
  <mat-card-title class="tw-flex tw-justify-between">
    <div class="tw-flex tw-items-center">
      <ui-svg-icon [name]="iconNameList.Components" [width]="32"></ui-svg-icon>
      {{ 'common.field.mainInfo' | translate }}
    </div>
    <ng-container *ngIf="profileForm" [formGroup]="profileForm">
      <mat-button-toggle-group class="toggle-s" formControlName="type">
        <mat-button-toggle
          *ngFor="let profileType of [monitoringProfileType.Private, monitoringProfileType.Public]"
          [value]="profileType"
          aria-label="{{ profileType }}"
          [disabled]="!(isUserProfileCreator || isCloned)"
        >
          {{ 'common.filter.profileType.option.' + profileType.toLowerCase() | translate }}
        </mat-button-toggle>
      </mat-button-toggle-group>
    </ng-container>
  </mat-card-title>
  <mat-card-content *ngIf="profileForm">
    <div [formGroup]="profileForm">
      <mat-form-field>
        <mat-label>{{ 'common.field.name' | translate }}*</mat-label>
        <input matInput formControlName="name" [readonly]="isProfileDetailsDisabled && !isCloned" />
        <mat-error>
          <ui-field-error-messages [control]="profileForm.get('name')"></ui-field-error-messages>
        </mat-error>
      </mat-form-field>

      <mat-form-field>
        <mat-label>{{ 'common.field.description' | translate }}</mat-label>
        <input matInput formControlName="description" [readonly]="isProfileDetailsDisabled && !isCloned" />
      </mat-form-field>
    </div>
  </mat-card-content>
</mat-card>
